import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/RecentMenuWithAnalyticQuery.graphql';

type EntryPointParams = { cloudId: string; count: number };

export const sidebarRecentMenuEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-nav4-sidebar-recent-menu" */ './RecentMenuWithAnalytic.tsx'
			),
	),
	getPreloadProps: ({ cloudId, count }: EntryPointParams) => ({
		queries: {
			recentMenuData: {
				parameters,
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				variables: {
					cloudId,
					count,
					keyword: '',
				},
			},
		},
	}),
});
